import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { LanguageService } from "libraries/service/language/language.service";
import { DateService } from "libraries/date/date.service";

/**
 * dateTimeRange
 * display au date under format:
 *  "le dim. 20 août 2017 entre 08:00 et 18:00+1"
 */
@Pipe({ name: 'dateTimeRange' })
export class DateTimeRangePipe implements PipeTransform {

    constructor(private readonly languageService: LanguageService,
                private readonly dateService: DateService) {
    }

    /**
     * @param {json} dates : {min: "2017-08-20T08:00:00", max: "2017-08-21T18:00:00"}
     */
    public transform(dates: any): string {
        let output: string = "";

        const language: string = this.languageService.getUserLanguage();
        moment.locale(language);

        const min: moment.Moment = moment.parseZone(dates.min).utc();
        const max: moment.Moment = moment.parseZone(dates.max).utc();

        output += min.format(this.dateService.dateFormats.momentMedium);
        output += " - ";
        output += min.format(this.dateService.dateFormats.momentTime);
        output += " - ";
        output += max.format(this.dateService.dateFormats.momentTime);

        // if min and max aren't the same day, had +X(days number) after the second time
        if (min.dayOfYear() !== max.dayOfYear()) {
            let diff: number;
            if (max.dayOfYear() > min.dayOfYear()) {
                diff = max.dayOfYear() - min.dayOfYear();
            } else {
                //from 01/01 to max
                const diff1 = max.dayOfYear();

                //get last day of min year
                const lastDayFirstYear = moment(min).endOf('year');
                const lastDayNumber = moment(lastDayFirstYear).dayOfYear();

                //from min to last day of min year
                const diff2 = lastDayNumber - min.dayOfYear();

                //get diff by addition
                //test on
                //https://codepen.io/ejallier/pen/XeRBrq?editors=1111
                //http://projets2.afidium.com/issues/15760
                diff = diff1 + diff2;
            }
            output += "<sup class='small'>+" + diff + "</sup>";
        }

        return output;
    }
}
